import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './recentTransactions.css'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    TablePagination,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';

const RecentTransactions = () => {
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedReciept, setSelectedReciept] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [address, setAddress] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');


    useEffect(() => {
        if (selectedReciept) {
            setPaymentMethod(selectedReciept.paymentMethod || '');
            setAddress(selectedReciept.address || '');
        }
    }, [selectedReciept]);

    useEffect(() => {
        const fetchRecentTransactions = async () => {
            try {
                const token = JSON.parse(sessionStorage.getItem('accessToken'));
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/save/userForms`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                const data = response.data;
                setTableData(data);
                setFilteredData(data);
            } catch (error) {
                console.error(error);
            }
        };
        fetchRecentTransactions();
    }, []);

    const handleSearch = (event) => {
        const keyword = event.target.value.toLowerCase();
        setSearch(keyword);
        // applyFilters()
    };

    const handleRowClick = (recieptId) => {
        const form = tableData.find((item) => item._id === recieptId);
        setSelectedReciept(form);
        setOpenDialog(true);
    };

    const handleSaveChanges = async () => {
        try {
            const scrapItems = selectedReciept.scrapItems.map(item => ({
                ...item,
                rate: parseFloat(item.rate) || 0,
                weight: parseFloat(item.weight) || 0
            }));

            const token = JSON.parse(sessionStorage.getItem('accessToken'));
            const totalWeight = scrapItems.reduce((sum, item) => sum + (item.weight || 0), 0);
            const totalAmount = scrapItems.reduce((sum, item) => sum + (item.weight * item.rate || 0), 0);

            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/save/updateForm/${selectedReciept._id}`,
                {
                    address,
                    paymentMethod,
                    scrapItems,
                    totalWeight,
                    totalAmount
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("Success:", response.data);
            setOpenDialog(false);
        } catch (error) {
            console.error("Error updating form:", error);
        }
    };

    const handleGeneratePDF = async (reciept) => {
        const userName = reciept.userId?.username || "Unknown";
        const userLocation = reciept.address || "N/A";
        const paymentMethod = reciept.paymentMethod || "Cash";
        const pickupDate = new Date(reciept.createdAt)
            .toLocaleDateString("en-GB")
            .replaceAll("/", "-");
        const transactionAmount = reciept.totalAmount || "0";

        // Convert scrapItems to required format
        const customRates = reciept.scrapItems.map((item) => ({
            scrapName: item.scrapId?.scrapName || "Unknown",
            enteredRate: item.rate || "0",
        }));

        const weights = reciept.scrapItems.reduce((acc, item) => {
            const name = item.scrapId?.scrapName || "Unknown";
            const weight = parseFloat(item.weight);

            if (weight > 0) {
                acc[name] = weight;
            }

            return acc;
        }, {});

        const indvScrapTotals = reciept.scrapItems.reduce((acc, item) => {
            const name = item.scrapId?.scrapName || "Unknown";
            acc[name] = item.total || "0";
            return acc;
        }, {});

        console.log("customRates:", customRates);
        console.log("weights:", weights);
        console.log("indvScrapTotals:", indvScrapTotals);

        try {
            const requestData = {
                userName,
                customRates,
                pickupDate,
                userLocation,
                paymentMethod,
                weights,
                indvScrapTotals,
                transactionAmount,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/admin/generatepdf`, 
                requestData,
                {
                    responseType: "blob",
                }
            );

            // if (!response.ok) throw new Error("Failed to generate PDF");

            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
            const downloadUrl = URL.createObjectURL(pdfBlob);

            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = `${userName}_Bill.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error("PDF generation failed:", error);
        }
    };

    return (
        <div style={{ padding: '40px' }}>
            <Typography variant="h3" style={{
                position: 'relative',
                top: 10,
            }}
                gutterBottom>
                Reciept History
            </Typography>
            <TextField
                label="Search Reciepts"
                variant="outlined"
                fullWidth
                margin="normal"
                value={search}
                onChange={handleSearch}
                placeholder="Search by username or phone"
            />

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Reciept Id</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>User Type</TableCell>
                            <TableCell>Created On</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((reciept) => (
                                <TableRow
                                    key={reciept._id}
                                    hover
                                    onClick={() => handleRowClick(reciept._id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <TableCell>{reciept._id}</TableCell>
                                    <TableCell>{reciept.userId?.username || 'N/A'}</TableCell>
                                    <TableCell>{reciept.userId?.phone || 'N/A'}</TableCell>
                                    <TableCell>{reciept.userId?.usertype || 'N/A'}</TableCell>
                                    <TableCell>
                                        {new Date(reciept.createdAt).toLocaleDateString('en-GB').replaceAll('/', '-')}
                                    </TableCell>

                                    <TableCell onClick={(e) => e.stopPropagation()}>
                                        <IconButton onClick={() => handleGeneratePDF(reciept)}>
                                            <DownloadIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>

                </Table>
            </TableContainer>

            <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) =>
                    setRowsPerPage(parseInt(event.target.value, 10))
                }
            />
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Receipt Details</DialogTitle>
                <DialogContent dividers>
                    {selectedReciept && (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Username"
                                        fullWidth
                                        value={selectedReciept.userId?.username || ''}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Phone Number"
                                        fullWidth
                                        value={selectedReciept.userId?.phone || ''}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Address"
                                        fullWidth
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Payment Method"
                                        fullWidth
                                        value={paymentMethod}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <br />
                            <Typography variant="h6">Scrap Details</Typography>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Scrap Name</TableCell>
                                        {/* <TableCell>Standard Rate</TableCell> */}
                                        <TableCell>Rate</TableCell>
                                        <TableCell>Weight</TableCell>
                                        <TableCell>Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedReciept.scrapItems?.map((item, idx) => {
                                        const rate = parseFloat(item.rate) || 0;
                                        const weight = parseFloat(item.weight) || 0;
                                        const total = rate * weight;

                                        return (
                                            <TableRow key={idx}>
                                                <TableCell>{item.scrapId?.scrapName}</TableCell>
                                                {/* <TableCell>{item.scrapId?.pricePerKg || '₹/kg'}</TableCell> */}
                                                <TableCell>
                                                    <TextField
                                                        value={item.rate}
                                                        onChange={(e) => {
                                                            const updatedItems = [...selectedReciept.scrapItems];
                                                            updatedItems[idx].rate = e.target.value;
                                                            setSelectedReciept({ ...selectedReciept, scrapItems: updatedItems });
                                                        }}
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        value={item.weight}
                                                        onChange={(e) => {
                                                            const updatedItems = [...selectedReciept.scrapItems];
                                                            updatedItems[idx].weight = e.target.value;
                                                            setSelectedReciept({ ...selectedReciept, scrapItems: updatedItems });
                                                        }}
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>₹ {!isNaN(total) ? total.toFixed(2) : '0.00'}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>

                            <Typography variant="h6" align="right" sx={{ mt: 2 }}>
                                Grand Total: ₹{" "}
                                {selectedReciept.scrapItems?.reduce((sum, item) => {
                                    const rate = parseFloat(item.rate) || 0;
                                    const weight = parseFloat(item.weight) || 0;
                                    return sum + (rate * weight);
                                }, 0).toFixed(2)}
                            </Typography>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="secondary">Close</Button>
                    <Button variant="contained" color="primary" onClick={handleSaveChanges}>Save Changes</Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default RecentTransactions;
